import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";

// import { ref, getDownloadURL } from "firebase/storage";
// import { storage } from "../../utils/firebase/firebase";

import CircularProgress from "@mui/material/CircularProgress";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";

import { XyzTransition } from "@animxyz/react";
import "@animxyz/core";

import { createClient } from "../../utils/axios/axios.utils";

const ProductsFromServer = ({
	handleInputChangeProducts,
	productsSell,
	handleRemoveProduct
}) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const [isLoading, setIsLoading] = useState(false);
	const [products, setProducts] = useState([]);
	const [sumProduct, setSumProduct] = useState(0);
	const [totalCart, setTotalCart] = useState(0);

	// const storageRef = ref(storage, `produtos-pitaya.json`);

	const getProductsQuery = async () => {
		setIsLoading(true);
		try {
			const { data: { data } } = await createClient('pitaya-products', null,{})
			setProducts(data)
		} catch (error) {
			console.log("erro ao pegar os produtos", error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		const totalValueCart = productsSell.reduce(
			(total, product) => total + product.valor,
			0
		);
		setSumProduct(totalValueCart);
	}, [productsSell]);


	useEffect(() => {
		const totalCart = productsSell.length;
		setTotalCart(totalCart);
	}, [productsSell]);

	useEffect(() => {
		if (products.length === 0) {
			getProductsQuery();
		}
	}, [products]);

	const renderOptions = (props, options) => {
		return (
			<li {...props} key={options.id}>
				{options.codigo}
			</li>
		);
	};
	return (
		<Box
			width="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
		>
			{isLoading && products.length === 0 && (
				<Box
					display="flex"
					justifyContent="center"
					sx={{ width: "100%" }}
				>
					<CircularProgress color="inherit" />
				</Box>
			)}
			{!isLoading && products.length > 0 && (
				<XyzTransition
				appear
				mode="out-in"
				xyz="fade ease right-5 out-ease out-right-5"
			>
				<Box
					display="flex"
					justifyContent={
						productsSell.length > 0 ? "space-between" : "center"
					}
					flexDirection="column"
					alignItems="center"
					sx={{
						width: "100%",
						backgroundColor: colors.pink[700],
						gap: "20px",
						padding: "20px 20px",
						borderRadius: "10px"
					}}
					xyz="fade flip-left perspective-1"
				>
					<Typography
						sx={{
							fontSize: "12px",
							color: colors.yellow[500],
							fontStyle: "italic"
						}}
					>
						Selecione pelo menos 1 produto
					</Typography>
					<Box
						sx={{
							width: "100%"
						}}
					>
						<Autocomplete
							disablePortal
							id="combo-box-demo"
							options={products}
							getOptionLabel={(option) => option.codigo}
							onChange={handleInputChangeProducts}
							sx={{
								width: "100%"
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									key={params.id}
									label="Código do Produto"
									type="tel"
								/>
							)}
							renderOption={renderOptions}
						/>
					</Box>
					{productsSell.length > 0 && (
						<Box
							display="flex"
							flexDirection="column"
							justifyContent="center"
							alignItems="center"
							sx={{
								width: "100%",
								gap: "5px",
								backgroundColor: colors.pink[600],
								borderRadius: "5px",
								padding: "0 5px"
							}}
						>
							{productsSell &&
								productsSell.map((items, i) => {
									const { tipo, valor } = products.filter(
										(e) =>
											Number(e.codigo) === Number(items.codigo)
									)[0];
									const formatValue = valor.toLocaleString(
										"pt-br",
										{
											style: "currency",
											currency: "BRL"
										}
									);

									const formatTipo = tipo.toLowerCase();
									return (
										<XyzTransition
											appear
											mode="out-in"
											xyz="fade ease right-5 out-ease out-right-5"
											key={i}
										>
											<Box
												display="flex"
												justifyContent="space-around"
												alignItems="center"
												sx={{
													width: "100%",
													padding: "5px 0"
												}}
												xyz="fade ease right-5 out-ease out-right-5"
											>
												<Box
													xyz="fade flip-down stagger duration-10 delay-2 ease-out-back"
													display="flex"
													alignItems="flex-end"
													flexGrow="1"
												>
													<CheckIcon
														sx={{
															color: colors
																.greenAccent[500]
														}}
													/>
													<span
														style={{
															marginLeft: "15px"
														}}
													>
														{items.codigo}&nbsp; -
														&nbsp;&nbsp;&nbsp;
														<span
															style={{
																textTransform:
																	"capitalize"
															}}
														>
															{formatTipo.length <
															2
																? "Sem Descrição"
																: formatTipo}
														</span>
														&nbsp;&nbsp;&nbsp; -
														&nbsp;&nbsp;
														{formatValue}
													</span>
												</Box>

												<IconButton
													onClick={() =>
														handleRemoveProduct(
															items.codigo,
															i
														)
													}
												>
													<DeleteForeverRoundedIcon
														sx={{
															color: "red",
															cursor: "pointer"
														}}
													/>
												</IconButton>
											</Box>
										</XyzTransition>
									);
								})}
							<Box
								sx={{
									width: "98%",
									height: "1px",
									backgroundColor: colors.grey[300],
									borderRadius: "10px"
								}}
							/>
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
								width="100%"
								sx={{
									padding: "0 10px",
									margin: "5px 0"
								}}
							>
								<Box>
									{totalCart === 1 ? "Item" : "Items"}:{" "}
									{totalCart}
								</Box>
								<Box>
									Subtotal:{" "}
									{sumProduct.toLocaleString("pt-br", {
										style: "currency",
										currency: "BRL"
									})}
								</Box>
							</Box>
						</Box>
					)}
				</Box>
				</XyzTransition>
			)}
		</Box>
	);
};

export default ProductsFromServer;
